<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="groupName">
        <span slot="label">
          <a-tooltip>分组名称<template slot="title">分组名称</template></a-tooltip>
        </span>
        <a-input v-model="form.groupName" :placeholder="$t('请输入')+'分组名称'"/>
      </a-form-model-item>
      <a-form-model-item prop="groupStatus">
        <span slot="label">
          <a-tooltip>分组状态<template slot="title">分组状态 1 激活  0禁用</template></a-tooltip>
        </span>
        <a-select v-model="form.groupStatus" placeholder="请选择" >
          <a-select-option :value="1">激活</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="firstService">
        <span slot="label">
          <a-tooltip>是否前置分组<template slot="title">是否前置分组</template></a-tooltip>
        </span>
        <a-select v-model="form.firstService" placeholder="请选择" >
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCustomerGroup, addCustomerGroup, updateCustomerGroup} from '@/api/customer/customerGroup'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        groupId: null,
        groupName: null,
        groupStatus: 1,
        firstService: 1,
        createTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        groupName: [{required: true, message: '分组名称' + this.$t('不能为空'), trigger: 'blur'}],
        groupStatus: [{
          required: true,
          message: '分组状态 1 激活  0禁用' + this.$t('不能为空'),
          trigger: 'blur'
        }],
        firstService: [{required: true, message: '是否前置分组' + this.$t('不能为空'), trigger: 'blur'}],
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        groupId: null,
        groupName: null,
        groupStatus: 1,
        firstService: 1,
        createTime: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCustomerGroup({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCustomerGroup(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCustomerGroup(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
